import styled from 'styled-components';

import { ModalDescription, ModalTitle } from 'basics/ModalAtoms';

import { flexColumn, flexRowSpaceBetween, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS } from 'styles/style-constants';

export const Heading = styled(ModalTitle)`
    margin-bottom: 1.2rem;
`;
export const Description = styled(ModalDescription)`
    margin-bottom: 2.8rem;
`;
export const Footer = styled.div`
    ${flexRowSpaceBetween};
    align-items: center;
    gap: 2rem;
    border-top: 1px solid ${COLORS.gray100};
    margin-top: 2.8rem;
    padding-top: 2.4rem;
    ${respondDown(Breakpoints.md)`
        flex-direction: column;
        align-items: stretch;
    `};
`;
export const Status = styled.div<{ $ready?: boolean }>`
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${({ $ready }) => ($ready ? COLORS.green500 : COLORS.textGray)};
`;
export const ErrorText = styled.div`
    margin-top: 1.6rem;
    font-size: 1.4rem;
    line-height: 2rem;
    color: ${COLORS.red500};
`;
export const ManualActions = styled.div`
    ${flexRowSpaceBetween};
    align-items: center;
    gap: 1.6rem;
    margin-bottom: 2rem;
    a {
        color: ${COLORS.purple500};
        font-size: 1.4rem;
    }
`;
export const InputLabel = styled.label`
    ${flexColumn};
    gap: 1.2rem;
    font-size: 1.4rem;
    color: ${COLORS.textPrimary};
`;
export const SignedInput = styled.textarea`
    width: 100%;
    min-height: 11rem;
    padding: 1.6rem;
    resize: vertical;
    border: 1px solid ${COLORS.gray100};
    border-radius: 0.8rem;
    font: inherit;
    color: ${COLORS.textPrimary};
`;
